import {actions, IToken} from "../store/sliceToken";
import {store} from "../store/configureStore";
import moment from "moment/moment";
import {fetchToken, ITokenRequest} from "./AuthRequest";
import {actions as modal} from "../store/sliceModal";
import {actions as actionsApp} from "../store/sliceApp";
import axios from "axios";
import {config} from "../config";


export interface IResponse {
    status: number | null;
    data: any;
    headers: Headers
    isSuccess: boolean;
    isError: boolean;
}

export async function requestBase(url: string, init: any, binary: boolean = false, isLoading: boolean = true): Promise<IResponse> {
    try {
        if (isLoading) {
            store.dispatch(actionsApp.showLoading())
        }
        return await fetch(url, init)
            .then(response => {
                    if (response.status === 204) {
                        return {
                            status: response.status,
                            data: [],
                            headers: response.headers,
                            isSuccess: true
                        } as IResponse;
                    }
                    if (binary) {
                        return response.blob().then(data => {
                            return {
                                status: response.status,
                                data: data,
                                headers: response.headers,
                                isSuccess: true
                            } as IResponse
                        })
                    }
                    if (response.status == 500) {
                        return {
                            status: response.status,
                            data: "Ошибка сервера",
                            headers: response.headers,
                            isSuccess: false,
                            isError: true
                        } as IResponse;
                    }
                if (response.status == 403) {
                    return {
                        status: response.status,
                        data: "Доступ запрещен",
                        headers: response.headers,
                        isSuccess: false,
                        isError: true
                    } as IResponse;
                }
                    return response.json()
                        .then(data => {
                            return {
                                status: response.status,
                                data,
                                headers: response.headers,
                                isSuccess: true
                            } as IResponse;
                        }).catch(ex => {
                            return {
                                status: response.status,
                                data: ex,
                                headers: response.headers,
                                isSuccess: false,
                                isError: true
                            } as IResponse;
                        })
                }
            ).catch(error => {
                return {isError: true, data: error} as IResponse
            })
    } catch (error) {
        return {isError: true, data: error} as IResponse
    } finally {
        store.dispatch(actionsApp.hideLoading())
    }
}


export async function requestWithToken(url: string, init: any, binary: boolean = false, isLoading: boolean = true): Promise<IResponse> {

    let token: IToken = store.getState().token;
    if (!token?.refresh_token) {
        alert("RequestBase.requestWithToken Обнуление на окно авторизации")
        store.dispatch(actions.clear())
        window.location.replace(`${config.uiStart}/auth`)
        return {status: 401} as IResponse;
    }
    if (moment().isAfter(token.expire)) {
        await fetchToken({
            grant_type: 'refresh_token',
            token: token.refresh_token,
        } as ITokenRequest, isLoading)

        token = store.getState().token;
    }

    let data = await requestBase(
        url,
        {
            ...init, headers: {
                ...init.headers, 'authorization': `${token.token_type} ${token.access_token}`
            },
        },
        binary,
        isLoading
    );


    if (data?.status == null) {
        store.dispatch(modal.showError("Ошибка запроса"))
    } else if (data.status != 401 && data.status >= 400) {
        store.dispatch(modal.showError(data.data))
    }
    return data;
}

export async function requestWithTokenAxios(url: string, init: any, binary: boolean = false): Promise<IResponse> {
    store.dispatch(actionsApp.showProgressBar(true))
    let token: IToken = store.getState().token;
    if (!token?.refresh_token) {
        alert("RequestBase.requestWithTokenAxios Обнуление на окно авторизации")
        store.dispatch(actions.clear())
        window.location.replace(`${config.uiStart}/auth`)
        return {status: 401} as IResponse;
    }
    if (moment().isAfter(token.expire)) {
        await fetchToken({
            grant_type: 'refresh_token',
            token: token.refresh_token,
        } as ITokenRequest)

        token = store.getState().token;
    }

    const onUploadProgress = (progressEvent: any) => {
        const { loaded, total } = progressEvent;
        let percent = Math.floor((loaded * 100) / total);
        if (percent < 100) {
            store.dispatch(actionsApp.setProgressBarValue(percent))
            // console.log(`${loaded} bytes of ${total} bytes. ${percent}%`);
        }
    };

    let data: IResponse = await axios.post(url, init.body, {
        headers: {
            ...init.headers, 'authorization': `${token.token_type} ${token.access_token}`
        },
        onUploadProgress
    }).then(response => {
        if (response.status > 200) {
            store.dispatch(modal.showError(response.data))
            return {
                status: response.status,
                data: response.data,
                headers: response.headers,
                isError: true
            } as unknown as IResponse;
        } else {
            return {
                status: response.status,
                data: response.data,
                headers: response.headers,
                isSuccess: true
            } as unknown as IResponse;
        }
    }).catch((err) => {
        return {
            status: err.status,
            data: err,
            isError: true
        } as IResponse;
    });

    if (data?.status == null) {
        store.dispatch(modal.showError("Ошибка запроса"))
    } else if (data.status != 401 && data.status >= 400) {
        store.dispatch(modal.showError(data.data))
    }
    return data;
}







